module.exports = __webpack_public_path__ + "img/Local-Storage.91e74be8.png";